// extracted by mini-css-extract-plugin
module.exports = {"defaultImage":"MNvWt"};